<div class="sh-action-bar-wrapper -sh-overlay" [class.-sh-dark]="darkMode">
  <div class="sh-action-bar" [ngClass]="{'-sh-on-dark': darkMode}">
    <div class="sh-action-bar__group">
      <div class="sh-action-bar__group__item">
        @if (showSelectionCheckbox) {
          <div class="sh-form-check">
            <input
              [indeterminate]="isIndeterminate$ | async"
              [formControl]="selectAllFormControl"
              type="checkbox"
              id="selection-checkbox"
              class="sh-checkbox sh-form-check__input"
              />
            <label for="selection-checkbox" class="sh-form-check__label -sh-on-dark">{{selectedItemsLabel$ | async}}</label>
          </div>
        } @else {
          <p class="sh-form-check__label -sh-on-dark">{{selectedItemsLabel$ | async}}</p>
        }
      </div>
    </div>
    <div class="sh-action-bar__group">
      <div class="sh-action-bar__group__item">
        <div class="sh-action-group -sh-condense -sh-wrap">
          @for (actionItem of actionItems$ | async; track actionItem) {
            <sh-action-item [item]="actionItem" class="sh-action-group__item"></sh-action-item>
          }
        </div>
      </div>
    </div>
  </div>
</div>
